import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { getShouldForwardProp } from 'utils/getShouldForwardProp';
import { AppText } from '../AppText/AppText';

export type AppLabelProps = {
    label: string;
    isFitContentWidth?: boolean;
    children: ReactNode;
    accessibilityLabel?: string;
};

const Container = styled.div.withConfig({
    shouldForwardProp: getShouldForwardProp(['isFitContentWidth']),
})<Pick<AppLabelProps, 'isFitContentWidth'>>`
    ${({ theme, isFitContentWidth }) => css`
        width: ${isFitContentWidth ? 'auto' : '100%'};
        display: flex;
        flex-direction: column;
        gap: ${theme.sizes.marginSmall}px;
    `}
`;

export const AppLabel = ({
    label,
    isFitContentWidth,
    children,
    accessibilityLabel,
}: AppLabelProps) => (
    <Container isFitContentWidth={isFitContentWidth} aria-label={accessibilityLabel}>
        <AppText margin={0} textType="BodyMSSemiBold">
            {label}
        </AppText>
        {children}
    </Container>
);
